// extracted by mini-css-extract-plugin
module.exports =  {"geosuggest-popup":"_93444fe79c--geosuggest-popup--j8epB","suggestion-list":"_93444fe79c--suggestion-list--NRzbC"};